
<!--
/**
* @copyright       Palace Resorts
* @description     Pantalla de LOGIN
* @author          Roberto Pérez Guzmán
* @creationDate    06 de Mayo del 2021
*/

-->

<template>
  <!-- CONTENIDO -->
  <v-container class="fill-height ma-0 pa-0" fluid no-gutters>

    <v-col class="primary fill-height d-none d-sm-block pr-bg"></v-col>
    <v-col cols="12" sm="6" md="5" lg="4" class="fill-height pa-0" align="center" justify="center" >
      <slot name="content"></slot>
    </v-col>
  </v-container>
</template>

<style>
.primary-color{
  color: #26a69a;
}
.pr-bg {
  background-image: url("~@/assets/bg/second-bg.png");
  background-repeat: no-repeat !important;
  -webkit-background-size: cover !important;
  -moz-background-size: cover !important;
  -o-background-size: cover !important;
  background-size: cover !important;
  background-position: center !important;
}

.pr-bg-login {
  background-image: linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%), url("~@/assets/header_img.png");
  background-repeat: no-repeat !important;
  -webkit-background-size: contain !important;
  -moz-background-size: cover !important;
  -o-background-size: cover !important;
  background-size: cover !important;
  background-position: center !important;
}

.header-login {
  position: absolute;
  width: 100%;
  height: 21vh;
  left: 0px;
  top: 0px;
}

.active-bc {
  color: #000;
  padding-bottom: 3px;
  padding-left:10px;
  padding-right:10px;
  box-shadow: inset 0 0px 0 white, inset 0 -3px 0 #26a69a

}

</style>
<script>
// Internacionalización. Para la presentación de mensajes en diferentes idiomas
import i18nMessages from "./i18n/anonimous.layout.messages";

export default {
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  components: {
    // Incluimos el layout que utilizará este módulo
    // Layout
  },
  data() {

    return {
      moduleName: 'ANONIMOUS_LAYOUT',

    };
  },
  methods: {
  }

};
</script>
